module.exports = __webpack_public_path__ + "img/tech 4.a6694a0f.png";